module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageLogin":{"breadcrumbs":{"index":"Přihlášení"},"loginHeading":"Přihlášení","register":{"button":"Registrovat se","heading":"Nemáte ještě účet?","subheading":"Proč se zaregistrovat?","text":"Mějte výhodné nabídky jako první ve své schránce. Spravujte pohodlně svůj účet a sledujte své objednávky odkudkoliv. Je to zdarma!"},"title":"Přihlášení"}}}')
  delete Component.options._Ctor
}
